import React, { useEffect } from 'react'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import tts from '../../lib/TTS'
import type { FocusableLinkProps } from './types'

function FocusableLink({
  children,
  className = '',
  disableTTS,
  focusKey,
  label = '',
  onEnterPress,
  onFocus,
  to,
}: FocusableLinkProps) {
  const navigate = useNavigate()
  const { ref, focused } = useFocusable({
    focusKey,
    onEnterPress: () => {
      if (onEnterPress) {
        onEnterPress()
      }

      if (to) {
        navigate(to)
      }
    },
    onFocus,
  })

  useEffect(() => {
    if (focused && label && !disableTTS) {
      tts.stopRead()
      tts.addTextToRead(`Focused on ${label}.`)
    }
  }, [focused, label])

  return (
    <div
      className={classNames('focusable-link', {
        [className]: !!className,
        'focusable-link--focused': focused,
      })}
      ref={ref}
    >
      {children}
    </div>
  )
}

export default FocusableLink
